import { TableHTMLAttributes } from 'react';
import classNames from 'classnames';
import { ApprovalFormTableRoot, ApprovalFormTableScroll } from './styles';

type ApprovalFormTableProps = TableHTMLAttributes<HTMLTableElement> & {
  /** 셀 패딩 없이 입력칸이 셀을 채우는 작성용 표 */
  editable?: boolean;
};

/** 결재 양식 본문 표 — 좁은 화면 가로 스크롤 포함 */
const ApprovalFormTable = ({
  editable = false,
  className,
  ...rest
}: ApprovalFormTableProps) => (
  <ApprovalFormTableScroll className="approval-form-table-scroll">
    <ApprovalFormTableRoot
      className={classNames(
        'approval-form-table',
        editable && 'is-editable',
        className,
      )}
      {...rest}
    />
  </ApprovalFormTableScroll>
);

export default ApprovalFormTable;
